// extracted by mini-css-extract-plugin
export var emptyState = "_59-d";
export var statCard = "_59-c";
export var table = "_59-0";
export var tableCell = "_59-4";
export var tableCellClickable = "_59-5 _59-4";
export var tableCellDefault = "_59-6 _59-4";
export var tableCellEmpty = "_59-8";
export var tableCellWithValue = "_59-7";
export var tableContainer = "_59-e";
export var tableHeaderWeight = "_59-1";
export var tableHeaderZone = "_59-2";
export var tableRowHeader = "_59-3";
export var viewModeButton = "_59-9";
export var viewModeButtonActive = "_59-a _59-9";
export var viewModeButtonInactive = "_59-b _59-9";